import { z } from 'zod';

export const CreateSeriesSchema = z.object({
  code: z
    .string()
    .min(1)
    .max(4)
    .regex(/^[A-Z]+$/, 'Series code must be uppercase letters'),
  fiscalYear: z.number().int().min(2000).max(2100),
  startingNumber: z.number().int().min(1).default(1),
  format: z.string().default('YEAR-NNNN'),
});
export type CreateSeriesRequest = z.infer<typeof CreateSeriesSchema>;

export const UpdateSeriesSchema = z.object({
  format: z.string().optional(),
  nextNumber: z.number().int().min(1).optional(),
  confirmNumberChange: z.boolean().optional(),
});
export type UpdateSeriesRequest = z.infer<typeof UpdateSeriesSchema>;
